const css = `.AhbK6q__inverseEmphasized{font-weight:700}.AhbK6q__conversionEventLabel{word-wrap:break-word}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"inverseEmphasized":"AhbK6q__inverseEmphasized","conversionEventLabel":"AhbK6q__conversionEventLabel"};
